(() => {
  const allowed = new Set(['BOTTLE_IMMEDIATE','BOTTLE_ON_ORDER','BOTTLE_RELEASE_PREORDER','DECANT_IMMEDIATE','DECANT_ON_ORDER','DECANT_RELEASE_PREORDER']);
  const statesFor = root => JSON.parse(root.querySelector('[data-astra-states]').textContent);
  const stateFor = (root, id) => statesFor(root)[String(id)];
  const validSet = root => {
    const selector = root.closest('product-info')?.querySelector('[data-fixed-set="true"]');
    return !selector || selector.dataset.fixedValid === 'true';
  };
  function apply(root, id) {
    const state = stateFor(root, id);
    root.dataset.variant = String(id || '');
    const interest = root.querySelector('[data-aparu-interest]');
    if (interest) {
      const returnInput = interest.querySelector('input[name="return_to"]');
      const interestForm = interest.querySelector('form');
      if (returnInput && interestForm) returnInput.value = location.pathname + '?variant=' + encodeURIComponent(id) + '&contact_posted=true#' + interestForm.id;
      interest.hidden = !!state && allowed.has(state.status) && state.available && validSet(root);
      const select = interest.querySelector('[data-interest-variant]');
      if (select && [...select.options].some(option => option.value.startsWith(String(id) + ' |'))) select.value = [...select.options].find(option => option.value.startsWith(String(id) + ' |')).value;
    }
    const product = root.closest('product-info');
    const permitted = !!state && allowed.has(state.status) && state.available && validSet(root);
    root.querySelectorAll('[data-astra-variant-row]').forEach(row => {
      if (row.dataset.astraVariantRow === String(id)) row.setAttribute('aria-current','true');
      else row.removeAttribute('aria-current');
    });
    for (const field of ['dispatch','note']) root.querySelector('[data-astra-'+field+']').textContent = state?.[field] || '';
    root.querySelector('[data-astra-label]').textContent = state?.label || '';
    root.querySelector('[data-astra-label]').hidden = !state?.label;
    const help = root.querySelector('[data-astra-help]');
    if (help) help.hidden = permitted;
    const payment = root.querySelector('[data-astra-payment]');
    if (payment) payment.hidden = !permitted || !state.status.endsWith('_ON_ORDER');
    root.querySelector('[data-astra-release]').textContent = state?.release_info || '';
    const details = document.querySelector('[data-astra-details-product="'+root.dataset.product+'"]');
    if(details)for(const [field,value] of Object.entries({'sku':state?.sku,'size':state?.display_title||state?.title,'ean':state?.barcode})){
      const node=details.querySelector('[data-astra-current-'+field+']');
      if(!node)continue;
      if(field==='ean'){
        const barcode=/^(5|10)\s*ml$/i.test(state?.title?.trim()||'')?'':value||'';
        node.textContent=barcode;
        const row=node.closest('[data-astra-ean-row]');
        if(row){row.hidden=!barcode;row.style.display=barcode?'':'none';}
      }else node.textContent=value||'–';
    }
    const detailDispatch=details?.querySelector('[data-astra-detail-dispatch]');if(detailDispatch)detailDispatch.textContent=state?.dispatch||'';
    product.querySelectorAll('product-form form').forEach(form => {
      const button = form.querySelector('[name="add"]');
      if (!button) return;
      button.disabled = !permitted;
      form.hidden = !permitted;
      const label = button.querySelector('span') || button;
      label.textContent = !permitted ? root.dataset.soldOutLabel : state.cta;
      for(const [key,value] of Object.entries({'Lieferstatus':state?.label,'Lieferzeitraum':state?.dispatch})) {
        let input = form.querySelector('[data-astra-property="'+key+'"]');
        if (!input) { input=document.createElement('input');input.type='hidden';input.name='properties['+key+']';input.dataset.astraProperty=key;form.appendChild(input); }
        input.value=value||''; input.disabled=!permitted || !value;
      }
    });
    product.querySelectorAll('input[name="quantity"]').forEach(input => {
      if (state?.capacity !== null && state?.capacity !== undefined) {
        input.max = String(state.capacity);
        input.dataset.max = String(state.capacity);
        input.dataset.aparuCapacity = 'true';
        if (Number(input.value) > state.capacity) input.value = String(Math.max(1, state.capacity));
      } else if (input.dataset.aparuCapacity) {
        input.removeAttribute('max'); delete input.dataset.max; delete input.dataset.aparuCapacity;
      }
    });
    const selector = product.querySelector('aparu-duftauswahl');
    if (selector?.knopfSteuern) selector.knopfSteuern(selector.auswahlAnzahl);
  }
  function init() {document.querySelectorAll('[data-astra-availability]').forEach(root=>apply(root,root.dataset.variant));}
  document.addEventListener('variant:change',event=>{
    const root=document.getElementById('AstraAvailability-'+event.detail.sectionId);
    if(root)apply(root,event.detail.variant?.id);
  });
  const checkedForms = new WeakSet();
  const pendingForms = new WeakSet();
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches('product-form form')) return;
    const root = form.closest('product-info')?.querySelector('[data-astra-availability]');
    if (!root) return;
    const id = new FormData(form).get('id');
    const state = stateFor(root, id);
    if (!state || !allowed.has(state.status) || !state.available || !validSet(root)) {
      event.preventDefault(); event.stopImmediatePropagation(); apply(root, id); return;
    }
    if (state.capacity === null || state.capacity === undefined) return;
    if (checkedForms.has(form)) { checkedForms.delete(form); return; }
    event.preventDefault(); event.stopImmediatePropagation();
    if (pendingForms.has(form)) return;
    pendingForms.add(form);
    const quantity = Number(new FormData(form).get('quantity') || 1);
    const input = form.closest('product-info').querySelector('input[name="quantity"]');
    const button = form.querySelector('[name="add"]');
    button.disabled = true;
    let nativeSubmitted = false;
    fetch(window.Shopify.routes.root + 'cart.js', {credentials: 'same-origin'})
      .then(response => { if (!response.ok) throw new Error('cart'); return response.json(); })
      .then(cart => {
        const inCart = cart.items.filter(item => String(item.variant_id) === String(id)).reduce((total, item) => total + item.quantity, 0);
        const remaining = Math.max(0, state.capacity - inCart);
        if (!Number.isInteger(quantity) || quantity < 1 || quantity > remaining) {
          const message = (theme.cartStrings.quantityError || '').replace('[quantity]', String(remaining));
          const error = form.closest('product-form').querySelector('.product-form__error-message');
          if (error) { error.textContent = message; error.parentElement.hidden = false; }
          if (input) { input.max = String(remaining); input.dataset.max = String(remaining); }
          return;
        }
        checkedForms.add(form); button.disabled = false; nativeSubmitted = true; form.requestSubmit(button);
      })
      .catch(() => {
        const error = form.closest('product-form').querySelector('.product-form__error-message');
        if (error) { error.textContent = root.dataset.soldOutLabel; error.parentElement.hidden = false; }
      })
      .finally(() => { pendingForms.delete(form); if (!nativeSubmitted) button.disabled = false; });
  }, true);
  document.addEventListener('click',async event=>{
    const button=event.target.closest('[data-astra-cookie-settings]');
    if(!button)return;
    button.disabled=true;
    try {
      if(!window.privacyBanner?.showPreferences) {
        await new Promise((resolve,reject)=>{
          const script=document.createElement('script');
          script.src='https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
          script.onload=resolve;
          script.onerror=reject;
          document.head.appendChild(script);
        });
      }
      await window.privacyBanner.showPreferences();
    } catch(error) {
      window.alert(button.dataset.errorMessage);
    } finally {
      button.disabled=false;
    }
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('visibilitychange',init);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, init);
})();

